import type { SectionLocale } from '../types'

export const ALLOCATE_COINS_LOCALE: SectionLocale = [
  [
    'allocate_coins_recipient_required',
    {
      ru: 'Выберите получателя',
      en: 'Select recipient',
    },
  ],
  [
    'allocate_coins_send_to_all',
    {
      ru: 'Отправить всем сотрудникам',
      en: 'Send to all employees',
    },
  ],
  [
    'allocate_coins_upload_bulk_list',
    {
      ru: 'Загрузить список',
      en: 'Upload list',
    },
  ],
  [
    'allocate_coins_upload_description_one',
    {
      ru: 'Можно загрузить файл формата xls или cvs с готовым списком сотрудников и начислений каждому.',
      en: 'You can upload a file in xls or cvs format with a ready-made list of employees and accruals for each.',
    },
  ],
  [
    'allocate_coins_upload_description_two',
    {
      ru: 'Чтобы избежать ошибок, используйте наш',
      en: 'To avoid mistakes, use our',
    },
  ],
  [
    'allocate_coins_upload_description_template',
    {
      ru: 'шаблон xlsx',
      en: 'xlsx template',
    },
  ],
  [
    'allocate_coins_upload_description_three',
    {
      ru: 'Указывайте только существующие адреса электронной почты, категории начисления. Коментарии до 200 символов. Каждому сотруднику можно начислить не более 200 монет.',
      en: 'Please only include valid email addresses and accrual categories. Comments are limited to 200 characters. Each employee can be awarded a maximum of 200 coins.',
    },
  ],
  [
    'allocate_coins_bulk_modal_title_upload',
    {
      ru: 'Загрузка файла',
      en: 'Upload file',
    },
  ],
  [
    'allocate_coins_bulk_modal_title_uploaded',
    {
      ru: 'Список для начисления загружен',
      en: 'The list for accrual has been loaded',
    },
  ],
  [
    'allocate_coins_bulk_modal_description_upload',
    {
      ru: 'Поддерживаемые форматы: .csv и .xlsx',
      en: 'Supported formats: .csv и .xlsx',
    },
  ],
  [
    'allocate_coins_bulk_modal_description_uploaded',
    {
      ru: 'Сотрудники получат корпоративную валюту в течение пары секунд. Все прошло успешно',
      en: 'Employees will receive their corporate currency within a couple of seconds. Everything went successfull',
    },
  ],
  [
    'allocate_coins_bulk_modal_action_stop',
    {
      ru: 'Остановить',
      en: 'Stop',
    },
  ],
  [
    'allocate_coins_bulk_modal_action_cancel',
    {
      ru: 'Отменить',
      en: 'Cancel',
    },
  ],
  [
    'allocate_coins_bulk_modal_action_close',
    {
      ru: 'Закрыть',
      en: 'Close',
    },
  ],
  [
    'allocate_coins_bulk_modal_action_allocate',
    {
      ru: 'Начислить коины',
      en: 'Allocate coins',
    },
  ],
  [
    'allocate_coins_bulk_modal_action_validation_loading',
    {
      ru: 'Идет проверка',
      en: 'Validating',
    },
  ],
  [
    'allocate_coins_bulk_modal_action_validation',
    {
      ru: 'Начать проверку',
      en: 'Start validation',
    },
  ],
  [
    'allocate_coins_bulk_modal_validation_error',
    {
      ru: 'Произошла ошибка при попытке валидации',
      en: 'Validating file error is occured',
    },
  ],
  [
    'allocate_coins_bulk_modal_allocate_error',
    {
      ru: 'Произошла ошибка при попытке начислить коины',
      en: 'Allocating coins error',
    },
  ],

  [
    'allocate_coins_bulk_error_file_too_large',
    {
      ru: 'Слишком большой размер файла',
      en: 'File is too large',
    },
  ],
  [
    'allocate_coins_bulk_error_unsupported_file_type',
    {
      ru: 'Неподдерживаемый формат файла',
      en: 'Unsupported file type',
    },
  ],
  [
    'allocate_coins_bulk_error_empty_file',
    {
      ru: 'Пустой файл',
      en: 'File is empty',
    },
  ],
  [
    'allocate_coins_bulk_error_missing_columns',
    {
      ru: ({ plural }) => plural(['Пропущена колонка', 'Пропущена колонка', 'Пропущены колонки']),
      en: ({ plural }) => plural(['Missing a columns', 'Missing a column', 'Missing a columns']),
    },
  ],

  [
    'allocate_coins_bulk_error_invalid_category',
    {
      ru: 'Некорректная категория',
      en: 'Category is invalid',
    },
  ],
  [
    'allocate_coins_bulk_error_invalid_coins_value',
    {
      ru: 'Некорректное значение коинов',
      en: 'Coins value is invalid',
    },
  ],
  [
    'allocate_coins_bulk_error_coins_out_of_range',
    {
      ru: 'Количество коинов вне зоны допустимых значений',
      en: 'Coins are out of range',
    },
  ],
  [
    'allocate_coins_bulk_error_comment_required',
    {
      ru: 'Требуется заполнить комментарий',
      en: 'Comment field is required',
    },
  ],
  [
    'allocate_coins_bulk_error_comment_too_long',
    {
      ru: 'Комментарий слишком большой',
      en: 'Comment is too long',
    },
  ],
  [
    'allocate_coins_bulk_error_duplicate_email',
    {
      ru: 'дублируется',
      en: 'is duplicated',
    },
  ],
  [
    'allocate_coins_bulk_error_user_not_found',
    {
      ru: 'нет в системе',
      en: 'is not in sytem',
    },
  ],
  [
    'allocate_coins_bulk_error_user_blocked',
    {
      ru: 'Пользователь заблокирован',
      en: 'User is blocked',
    },
  ],
  [
    'allocate_coins_bulk_error_email_empty',
    {
      ru: 'Не указан email',
      en: 'Email is empty',
    },
  ],
  [
    'allocate_coins_bulk_error_invalid_email',
    {
      ru: 'Некорректный формат email',
      en: 'Invalid email format',
    },
  ],
  [
    'allocate_coins_bulk_error_first_name_empty',
    {
      ru: 'Поле Имя не заполнено',
      en: 'First name is empty',
    },
  ],
  [
    'allocate_coins_bulk_error_last_name_empty',
    {
      ru: 'Поле Фамилия не заполнено',
      en: 'Last name is empty',
    },
  ],
  [
    'allocate_coins_bulk_file_status_uploaded',
    {
      ru: 'Файл успешно загружен',
      en: 'File is successfully uploaded',
    },
  ],
  [
    'allocate_coins_bulk_file_description_uploaded_title',
    {
      ru: 'Сотрудников в списке',
      en: 'Employees in list',
    },
  ],
  [
    'allocate_coins_bulk_file_description_uploaded_subtitle',
    {
      ru: 'Каждому сотруднику будет начисленно индивидуальное количество коинов. Общая сумма начисления:',
      en: 'Each employee will be awarded a specific number of coins. Total accrual amount:',
    },
  ],
  [
    'allocate_coins_bulk_file_description_uploaded_coins',
    {
      ru: ({ plural, named }) => plural(['0 коинов', '1 коин', `${named('count')} коина(ов)`]),
      en: ({ plural, named }) => plural(['0 coins', '1 coin', `${named('count')} coins`]),
    },
  ],
  [
    'allocate_coins_bulk_file_status_upload_failed',
    {
      ru: 'Не удалось обработать файл',
      en: 'Can not handle file',
    },
  ],
  [
    'allocate_coins_bulk_file_description_upload_failed',
    {
      ru: ({ plural, named }) =>
        plural([
          'Мы обнаружили 0 ошибок в файле.',
          'Мы обнаружили 1 ошибку в файле.',
          `Мы обнаружили ${named('count')} ошибок в файле.`,
        ]),
      en: ({ plural, named }) =>
        plural([
          'We found 0 mistakes in file.',
          'We found 1 mistake in file.',
          `We found ${named('count')} mistakes in file.`,
        ]),
    },
  ],
  [
    'allocate_coins_bulk_row',
    {
      ru: 'Строка',
      en: 'Row',
    },
  ],
  [
    'allocate_coins_comment_description',
    {
      ru: 'Поле является обязательным. Необходимо указать причину начисления коинов.',
      en: 'This field is required. Please provide a reason for allocating coins.',
    },
  ],
  [
    'allocate_coins_withdraw_comment_description',
    {
      ru: 'Поле является обязательным. Необходимо указать причину списания коинов.',
      en: 'This field is required. Please provide a reason for withdrawing coins.',
    },
  ],
  [
    'allocate_coins_task_link_description',
    {
      ru: 'Указывайте здесь строго только ссылку на задачу. Если нет связанной задачи, то поле можно оставить пустым.',
      en: 'Please only include a link to the task here. If there is no related task, you can leave the field empty.',
    },
  ],

  [
    'allocate_coins_bulk_error_missing_column_comment',
    {
      ru: 'Комментарий',
      en: 'Comment',
    },
  ],
  [
    'allocate_coins_bulk_error_missing_column_coins',
    {
      ru: 'Коины',
      en: 'Coins',
    },
  ],
  [
    'allocate_coins_bulk_error_missing_column_category',
    {
      ru: 'Категория',
      en: 'Category',
    },
  ],
  [
    'allocate_coins_bulk_error_missing_column_first_name',
    {
      ru: 'Имя',
      en: 'First name',
    },
  ],
  [
    'allocate_coins_bulk_error_missing_column_last_name',
    {
      ru: 'Фамилия',
      en: 'Last name',
    },
  ],
  [
    'allocate_coins_bulk_error_missing_column_email',
    {
      ru: 'Email',
      en: 'Email',
    },
  ],
  [
    'allocate_coins_withdraw_zero_coins_user',
    {
      ru: 'У выбранного(ых) пользователя(ей) нет коинов для списания',
      en: 'Selected user(s) have no coins to withdraw',
    },
  ],
  [
    'allocate_coins_confirm_sending',
    {
      ru: 'Подтвердите отправку',
      en: 'Confirm sending',
    },
  ],
  [
    'allocate_coins_confirm_withdrawal',
    {
      ru: 'Подтвердите списание',
      en: 'Confirm withdrawal',
    },
  ],
]
